export type RuntimeEnvKey =
  | "REACT_APP_SOFTPHONE_URL"
  | "REACT_APP_SOFTPHONE_ALLOWED_ORIGIN"
  | "REACT_APP_SOFTPHONE_AUTO_REGISTER"
  | "REACT_APP_TEAMS_BOT_API_BASE_URL"
  | "REACT_APP_ONBOARDING_REDIRECT_URI"
  | "REACT_APP_TEAMS_WEB_APPLICATION_ID"
  | "REACT_APP_TEAMS_WEB_CLIENT_APP_ID"
  | "REACT_APP_TEAMS_DESKTOP_CLIENT_APP_ID"
  | "REACT_APP_NODE_ENV"
  | "REACT_APP_PRIVACY_URL"
  | "REACT_APP_TERMS_URL"
  | "REACT_APP_SUPPORT_URL"
  | "REACT_APP_CLIENT_LOG_MAX_BATCH_BYTES"
  | "REACT_APP_VERSION_CHECK_INTERVAL_SECONDS";

declare global {
  interface Window {
    __ENV__?: Partial<Record<RuntimeEnvKey, string>>;
  }
}

// window.__ENV__ é gerado em runtime pelo server/server.js (imagem Docker); process.env é o
// fallback usado em dev local (npm start), onde o env.js não existe.
export function getRuntimeEnv(key: RuntimeEnvKey): string | undefined {
  return window.__ENV__?.[key] || process.env[key];
}
